/**
 * Mobile arc — platform detection.
 *
 * The ONE switch the web app consults to know it's running inside the
 * Capacitor shell (vs the browser at /v2). Kept dependency-free: reads
 * the global Capacitor bridge object instead of importing
 * @capacitor/core so web bundles don't grow and tests don't need the
 * package loaded.
 */

interface CapacitorGlobal {
  isNativePlatform?: () => boolean;
}

export function isNativeApp(): boolean {
  const cap = (globalThis as { Capacitor?: CapacitorGlobal }).Capacitor;
  return cap?.isNativePlatform?.() === true;
}

/**
 * Router basename: the web app deploys under /v2; the Capacitor shell
 * serves the SPA at its own root.
 */
export function routerBasename(): string {
  return isNativeApp() ? '/' : '/v2';
}
